/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EuAiActRiskClassEnum } from './EuAiActRiskClassEnum';
import {
  EuAiActRiskClassEnumFromJSON,
  EuAiActRiskClassEnumFromJSONTyped,
  EuAiActRiskClassEnumToJSON,
} from './EuAiActRiskClassEnum';
import type { MaterialityEnum } from './MaterialityEnum';
import { MaterialityEnumFromJSON, MaterialityEnumFromJSONTyped, MaterialityEnumToJSON } from './MaterialityEnum';

/**
 *
 * @export
 * @interface UseCaseWrite
 */
export interface UseCaseWrite {
  /**
   *
   * @type {number}
   * @memberof UseCaseWrite
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof UseCaseWrite
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UseCaseWrite
   */
  businessOwner: string;
  /**
   *
   * @type {string}
   * @memberof UseCaseWrite
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof UseCaseWrite
   */
  purpose: string;
  /**
   *
   * @type {Array<number>}
   * @memberof UseCaseWrite
   */
  department?: Array<number>;
  /**
   *
   * @type {EuAiActRiskClassEnum}
   * @memberof UseCaseWrite
   */
  euAiActRiskClass: EuAiActRiskClassEnum;
  /**
   *
   * @type {MaterialityEnum}
   * @memberof UseCaseWrite
   */
  materiality?: MaterialityEnum | null;
}

/**
 * Check if a given object implements the UseCaseWrite interface.
 */
export function instanceOfUseCaseWrite(value: object): value is UseCaseWrite {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('businessOwner' in value) || value['businessOwner'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined) return false;
  if (!('purpose' in value) || value['purpose'] === undefined) return false;
  if (!('euAiActRiskClass' in value) || value['euAiActRiskClass'] === undefined) return false;
  return true;
}

export function UseCaseWriteFromJSON(json: any): UseCaseWrite {
  return UseCaseWriteFromJSONTyped(json, false);
}

export function UseCaseWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): UseCaseWrite {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    businessOwner: json['business_owner'],
    description: json['description'],
    purpose: json['purpose'],
    department: json['department'] == null ? undefined : json['department'],
    euAiActRiskClass: EuAiActRiskClassEnumFromJSON(json['eu_ai_act_risk_class']),
    materiality: json['materiality'] == null ? undefined : MaterialityEnumFromJSON(json['materiality']),
  };
}

export function UseCaseWriteToJSON(value?: Omit<UseCaseWrite, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    business_owner: value['businessOwner'],
    description: value['description'],
    purpose: value['purpose'],
    department: value['department'],
    eu_ai_act_risk_class: EuAiActRiskClassEnumToJSON(value['euAiActRiskClass']),
    materiality: MaterialityEnumToJSON(value['materiality']),
  };
}
